import PostsIcon from "assets/icons/PostsIcon"
import ReelsIcon from "assets/icons/ReelsIcon"
import React, { useState } from "react"
import { Nav, NavItem, TabContent, TabPane } from "reactstrap"
import InfluencerPosts from "./InfluencerPosts"
import InfluencerReels from "./InfluencerReels"
import { Post, SocialAccount } from "types/influencer"
import InfluencerRelevantMedia from "./InfluencerRelevantMedia"
import TargetMediaIcon from "assets/icons/TargetMediaIcon"
import { SocialPost } from "types/campaign/collaborations"
import InfluencerYTVideos from "./InfluencerYTVideos"

interface InfluencerContentProps {
    influencerId: string,
    socialAccountId: string,
    onMediaClick: (post: SocialPost) => void
    socialAccount: SocialAccount
}
const InfluencerContent: React.FC<InfluencerContentProps> = ({ influencerId, socialAccountId, onMediaClick, socialAccount }) => {

    const [activeTab, setActiveTab] = useState<string>(socialAccount?.platform === 'yt' ? 'videos' : 'reels');

    return (
        <div>
            <Nav tabs className="d-flex w-100 justify-content-around">
                {
                    socialAccount.platform === 'yt' &&
                    <NavItem onClick={() => setActiveTab('videos')} className={`w-33 text-center align-self-center cursor-pointer border-top-1 ${activeTab === 'videos' && 'border-top-active'} py-2`}>
                        <span>
                            <i className="ri-youtube-fill" style={{ fontSize: '28px', color: activeTab === 'videos' ? '#212121' : '#9A9A9A' }}></i>
                        </span>
                    </NavItem>
                }
                {
                    socialAccount.platform === 'ig' &&
                    <>
                        <NavItem onClick={() => setActiveTab('reels')} className={`w-33 text-center align-self-center cursor-pointer border-top-1 ${activeTab === 'reels' && 'border-top-active'} py-3`}>
                            <span>
                                <ReelsIcon color={activeTab === 'reels' ? '#212121' : '#9A9A9A'} />
                            </span>
                        </NavItem>
                        <NavItem onClick={() => setActiveTab('posts')} className={`w-33 text-center align-self-center cursor-pointer border-top-1 ${activeTab === 'posts' && 'border-top-active'} py-3`}>
                            <span >
                                <PostsIcon color={activeTab === 'posts' ? '#212121' : '#9A9A9A'} />
                            </span>
                        </NavItem>
                    </>
                }
                <NavItem onClick={() => setActiveTab('relevant')} className={`w-33 text-center align-self-center cursor-pointer border-top-1 ${activeTab === 'relevant' && 'border-top-active'} py-3`}>
                    <span>
                        <TargetMediaIcon color={activeTab === 'relevant' ? '#212121' : '#9A9A9A'} />
                    </span>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                {
                    socialAccount.platform === 'yt' &&
                    <TabPane tabId="videos">
                        <InfluencerYTVideos onMediaClick={onMediaClick} socialAccountId={socialAccountId} />
                    </TabPane>
                }
                {
                    socialAccount.platform === 'ig' &&
                    <>
                        <TabPane tabId="reels">
                            <InfluencerReels onMediaClick={onMediaClick} socialAccountId={socialAccountId} />
                        </TabPane>
                        <TabPane tabId="posts">
                            <InfluencerPosts onMediaClick={onMediaClick} socialAccountId={socialAccountId} />
                        </TabPane>
                    </>
                }
                <TabPane tabId="relevant">
                    <InfluencerRelevantMedia onMediaClick={onMediaClick} influencerId={influencerId} />
                </TabPane>
            </TabContent>
        </div>
    )
}

export default InfluencerContent